import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { IButton, TranslateService } from '@devinforius/i-essentials';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-duplicate-modals',
  templateUrl: './duplicate-modals.component.html',
  styleUrls: ['./duplicate-modals.component.scss'],
})
export class DuplicateModalsComponent implements OnInit {
  public formDuplicate = new UntypedFormGroup({
    all: new UntypedFormControl(false),
    files: new UntypedFormControl(false),
    destinataires: new UntypedFormControl(false),
    links: new UntypedFormControl(false),
  });
  public courrier;

  public titleButtons: IButton[] = [
    {
      text: 'cancel',
      styleClass: 'blue',
      click: () => {
        this.close();
      },
    },
    {
      text: 'confirm',
      styleClass: 'green',
      click: () => {
        this.duplicate();
      },
    },
  ];

  constructor(
    public router: Router,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private translater: TranslateService
  ) {}

  ngOnInit(): void {
    this.titleButtons = this.titleButtons.map((button) => ({ ...button, text: this.translater.translate(button.text) }));
    if (this.config?.data) {
      this.courrier = this.config.data.courrier;
    }
  }

  checkAll(event: { pointerEvent: PointerEvent; checked: boolean }): void {
    if (event.checked) {
      this.formDuplicate.patchValue({
        files: event.checked,
        destinataires: event.checked,
        links: event.checked,
      });
    }
  }

  unCheckTheAllControl(event: { pointerEvent: PointerEvent; checked: boolean }): void {
    if (!event.checked) {
      this.formDuplicate.patchValue({
        all: false,
      });
    }
  }

  close(): void {
    this.ref.close();
  }

  duplicate(): void {
    const datas = {
      data: true,
      classements: true,
      files: this.formDuplicate.value.files,
      destinataires: this.formDuplicate.value.destinataires,
      links: this.formDuplicate.value.links,
    };
    sessionStorage.setItem('duplicateForm', JSON.stringify(datas));
    this.router.navigate(['/private/ic/new/' + this.courrier.id, { mode: 'duplicate' }]);
    this.close();
  }
}
